import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ps-panel" }
const _hoisted_2 = {
  key: 0,
  class: "install-app-card"
}
const _hoisted_3 = {
  key: 1,
  class: "install-app-card install-app-card--done"
}
const _hoisted_4 = { class: "offline-section" }
const _hoisted_5 = { class: "offline-row-header" }
const _hoisted_6 = {
  key: 0,
  class: "offline-stats-row"
}
const _hoisted_7 = { class: "offline-stat-item" }
const _hoisted_8 = { class: "offline-stat-val" }
const _hoisted_9 = {
  key: 0,
  class: "offline-stat-item"
}
const _hoisted_10 = {
  key: 1,
  class: "offline-stat-item"
}
const _hoisted_11 = { class: "offline-stat-val offline-stat-val--warn" }
const _hoisted_12 = {
  key: 1,
  class: "offline-progress"
}
const _hoisted_13 = { class: "offline-progress-track" }
const _hoisted_14 = { class: "offline-progress-label" }
const _hoisted_15 = { class: "offline-btns" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 2,
  class: "install-instructions"
}
const _hoisted_20 = { class: "storage-modal" }
const _hoisted_21 = { class: "storage-modal-header" }
const _hoisted_22 = {
  key: 0,
  class: "storage-loading"
}
const _hoisted_23 = { class: "storage-total-block" }
const _hoisted_24 = { class: "storage-total-numbers" }
const _hoisted_25 = { class: "storage-used-label" }
const _hoisted_26 = { class: "storage-quota-label" }
const _hoisted_27 = { class: "storage-bar-track" }
const _hoisted_28 = { class: "storage-bar-caption" }
const _hoisted_29 = { class: "storage-breakdown" }
const _hoisted_30 = { class: "storage-breakdown-label" }
const _hoisted_31 = { class: "storage-breakdown-value" }
const _hoisted_32 = { class: "storage-actions" }
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "ps-panel-hd" }, [
        _createElementVNode("h2", null, "Modo Offline"),
        _createElementVNode("p", null, "Permite usar o sistema sem internet e sincronizar ao reconectar.")
      ], -1)),
      (_ctx.isInstallable && !_ctx.isInstalled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"install-app-icon\" data-v-d06f7252><svg width=\"22\" height=\"22\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-d06f7252><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"4\" data-v-d06f7252></rect><path d=\"M12 8v8M8 12l4 4 4-4\" data-v-d06f7252></path></svg></div><div class=\"install-app-text\" data-v-d06f7252><span class=\"install-app-title\" data-v-d06f7252>Instalar como app no desktop</span><span class=\"install-app-desc\" data-v-d06f7252>Abre em janela própria, sem barra de endereço, como um app nativo.</span></div>", 2)),
            _createElementVNode("button", {
              class: "btn btn-primary btn-login",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.promptInstall && _ctx.promptInstall(...args)))
            }, "Instalar")
          ]))
        : (_ctx.isInstalled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[11] || (_cache[11] = [
              _createStaticVNode("<div class=\"install-app-icon install-app-icon--done\" data-v-d06f7252><svg width=\"22\" height=\"22\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-d06f7252><polyline points=\"20 6 9 17 4 12\" data-v-d06f7252></polyline></svg></div><div class=\"install-app-text\" data-v-d06f7252><span class=\"install-app-title\" data-v-d06f7252>App instalado</span><span class=\"install-app-desc\" data-v-d06f7252>O ObraTycoon está instalado neste dispositivo como app.</span></div>", 2)
            ]))]))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "offline-label" }, [
            _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 16 16",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.4"
            }, [
              _createElementVNode("path", {
                d: "M1 1l14 14M11.2 4.8A5 5 0 0 1 13 8M2.5 5.5A7 7 0 0 0 3.5 12M6 3.2A7 7 0 0 1 13 8m-6.5 1A2.5 2.5 0 0 1 10.5 8M5.5 12l.5.5a2.5 2.5 0 0 0 3.5 0L10 12",
                "stroke-linecap": "round"
              })
            ]),
            _createTextVNode(" Modo offline ")
          ], -1)),
          _createElementVNode("span", {
            class: _normalizeClass(["offline-pill", _ctx.offlineEnabled ? 'offline-pill--on' : 'offline-pill--off'])
          }, _toDisplayString(_ctx.offlineEnabled ? 'Ativado' : 'Desativado'), 3)
        ]),
        (_ctx.offlineEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "offline-stat-label" }, "Última sincronização", -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.lastSyncLabel), 1)
              ]),
              (_ctx.daysUntilBlock !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "offline-stat-label" }, "Dias restantes", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["offline-stat-val", { 'offline-stat-val--warn': _ctx.daysUntilBlock <= 5 }])
                    }, _toDisplayString(_ctx.daysUntilBlock === 0 ? 'Expirado' : `${_ctx.daysUntilBlock}d`), 3)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.offlinePendingCount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "offline-stat-label" }, "Pendentes", -1)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.offlinePendingCount), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.offlineDownloading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: "offline-progress-fill",
                  style: _normalizeStyle({ width: _ctx.offlineDownloadPct + '%' })
                }, null, 4)
              ]),
              _createElementVNode("span", _hoisted_14, "Baixando… " + _toDisplayString(_ctx.offlineDownloadPct) + "%", 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          (!_ctx.offlineEnabled)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary btn-login",
                type: "button",
                disabled: _ctx.offlineDownloading,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleEnableOffline && _ctx.handleEnableOffline(...args)))
              }, [...(_cache[16] || (_cache[16] = [
                _createElementVNode("svg", {
                  width: "13",
                  height: "13",
                  viewBox: "0 0 13 13",
                  fill: "none"
                }, [
                  _createElementVNode("path", {
                    d: "M6.5 1v8M3 6l3.5 3.5L10 6",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  _createElementVNode("path", {
                    d: "M1 11h11",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round"
                  })
                ], -1),
                _createTextVNode(" Ativar modo offline ", -1)
              ]))], 8, _hoisted_16))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("button", {
                  class: "btn btn-primary btn-login",
                  type: "button",
                  disabled: _ctx.offlineDownloading,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleEnableOffline && _ctx.handleEnableOffline(...args)))
                }, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("svg", {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 13 13",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M11 6.5A4.5 4.5 0 112 6.5",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    }),
                    _createElementVNode("path", {
                      d: "M11 3.5v3h-3",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1),
                  _createTextVNode(" Atualizar dados ", -1)
                ]))], 8, _hoisted_17),
                _createElementVNode("button", {
                  class: "btn btn-ghost btn-login",
                  type: "button",
                  disabled: _ctx.offlineDownloading,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDisableOffline && _ctx.handleDisableOffline(...args)))
                }, "Desativar", 8, _hoisted_18)
              ], 64)),
          _createElementVNode("button", {
            class: "btn btn-ghost btn-login storage-btn",
            type: "button",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openStorageModal && _ctx.openStorageModal(...args)))
          }, [...(_cache[18] || (_cache[18] = [
            _createStaticVNode("<svg width=\"13\" height=\"13\" viewBox=\"0 0 14 14\" fill=\"none\" data-v-d06f7252><ellipse cx=\"7\" cy=\"4\" rx=\"5\" ry=\"2\" stroke=\"currentColor\" stroke-width=\"1.3\" data-v-d06f7252></ellipse><path d=\"M2 4v2c0 1.1 2.24 2 5 2s5-.9 5-2V4\" stroke=\"currentColor\" stroke-width=\"1.3\" data-v-d06f7252></path><path d=\"M2 6v2c0 1.1 2.24 2 5 2s5-.9 5-2V6\" stroke=\"currentColor\" stroke-width=\"1.3\" data-v-d06f7252></path><path d=\"M2 8v2c0 1.1 2.24 2 5 2s5-.9 5-2V8\" stroke=\"currentColor\" stroke-width=\"1.3\" data-v-d06f7252></path></svg> Armazenamento ", 2)
          ]))])
        ]),
        _createElementVNode("button", {
          class: "install-toggle",
          type: "button",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showInstall = !_ctx.showInstall))
        }, [
          _cache[20] || (_cache[20] = _createElementVNode("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 14 14",
            fill: "none"
          }, [
            _createElementVNode("rect", {
              x: "2",
              y: "1",
              width: "10",
              height: "12",
              rx: "2",
              stroke: "currentColor",
              "stroke-width": "1.3"
            }),
            _createElementVNode("path", {
              d: "M5 4h4M5 7h4M5 10h2",
              stroke: "currentColor",
              "stroke-width": "1.2",
              "stroke-linecap": "round"
            })
          ], -1)),
          _cache[21] || (_cache[21] = _createTextVNode(" Como adicionar no celular ", -1)),
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["install-chevron", { open: _ctx.showInstall }]),
            width: "10",
            height: "10",
            viewBox: "0 0 11 11",
            fill: "none"
          }, [...(_cache[19] || (_cache[19] = [
            _createElementVNode("path", {
              d: "M2 4l3.5 3.5L9 4",
              stroke: "currentColor",
              "stroke-width": "1.4",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))], 2))
        ]),
        (_ctx.showInstall)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[22] || (_cache[22] = [
              _createStaticVNode("<div class=\"install-platform\" data-v-d06f7252><p class=\"install-platform-name\" data-v-d06f7252><svg width=\"13\" height=\"13\" viewBox=\"0 0 16 16\" fill=\"none\" data-v-d06f7252><path d=\"M8 1C4.134 1 1 4.134 1 8s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7z\" stroke=\"currentColor\" stroke-width=\"1.3\" data-v-d06f7252></path><path d=\"M5.5 8l1.5 1.5L10.5 6\" stroke=\"currentColor\" stroke-width=\"1.3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-d06f7252></path></svg> iPhone / iPad (iOS) </p><ol class=\"install-steps\" data-v-d06f7252><li data-v-d06f7252>Abra o Safari e acesse este endereço</li><li data-v-d06f7252>Toque em compartilhar <strong data-v-d06f7252>⎋</strong> na barra inferior</li><li data-v-d06f7252>Toque em <strong data-v-d06f7252>&quot;Adicionar à Tela de Início&quot;</strong></li><li data-v-d06f7252>Confirme com <strong data-v-d06f7252>&quot;Adicionar&quot;</strong></li></ol></div><div class=\"install-platform\" data-v-d06f7252><p class=\"install-platform-name\" data-v-d06f7252><svg width=\"13\" height=\"13\" viewBox=\"0 0 16 16\" fill=\"none\" data-v-d06f7252><path d=\"M3 3l4 4-4 4M9 11h4\" stroke=\"currentColor\" stroke-width=\"1.3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-d06f7252></path></svg> Android (Chrome) </p><ol class=\"install-steps\" data-v-d06f7252><li data-v-d06f7252>Abra o Chrome e acesse este endereço</li><li data-v-d06f7252>Toque no menu <strong data-v-d06f7252>⋮</strong> no canto superior direito</li><li data-v-d06f7252>Toque em <strong data-v-d06f7252>&quot;Adicionar à tela inicial&quot;</strong></li><li data-v-d06f7252>Confirme com <strong data-v-d06f7252>&quot;Adicionar&quot;</strong></li></ol></div>", 2)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.storageOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "crop-overlay",
          onMousedown: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.storageOpen = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[25] || (_cache[25] = _createStaticVNode("<h3 class=\"storage-modal-title\" data-v-d06f7252><svg width=\"16\" height=\"16\" viewBox=\"0 0 14 14\" fill=\"none\" data-v-d06f7252><ellipse cx=\"7\" cy=\"4\" rx=\"5\" ry=\"2\" stroke=\"currentColor\" stroke-width=\"1.4\" data-v-d06f7252></ellipse><path d=\"M2 4v2c0 1.1 2.24 2 5 2s5-.9 5-2V4\" stroke=\"currentColor\" stroke-width=\"1.4\" data-v-d06f7252></path><path d=\"M2 6v2c0 1.1 2.24 2 5 2s5-.9 5-2V6\" stroke=\"currentColor\" stroke-width=\"1.4\" data-v-d06f7252></path><path d=\"M2 8v2c0 1.1 2.24 2 5 2s5-.9 5-2V8\" stroke=\"currentColor\" stroke-width=\"1.4\" data-v-d06f7252></path></svg> Armazenamento </h3>", 1)),
              _createElementVNode("button", {
                class: "storage-close",
                type: "button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.storageOpen = false))
              }, [...(_cache[24] || (_cache[24] = [
                _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 16 16",
                  fill: "none"
                }, [
                  _createElementVNode("path", {
                    d: "M3 3l10 10M13 3L3 13",
                    stroke: "currentColor",
                    "stroke-width": "1.6",
                    "stroke-linecap": "round"
                  })
                ], -1)
              ]))])
            ]),
            (_ctx.storageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[26] || (_cache[26] = [
                  _createElementVNode("div", { class: "storage-spinner" }, null, -1),
                  _createTextVNode(" Calculando… ", -1)
                ]))]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.storageUsedFmt), 1),
                      _createElementVNode("span", _hoisted_26, "de " + _toDisplayString(_ctx.storageQuotaFmt), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", {
                        class: "storage-bar-fill",
                        style: _normalizeStyle({ width: _ctx.storageUsedPct + '%', background: _ctx.storageBarColor })
                      }, null, 4)
                    ]),
                    _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.storageUsedPct) + "% do armazenamento do navegador utilizado", 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "storage-breakdown-title" }, "Detalhamento", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storageBreakdown, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "storage-breakdown-row",
                        key: item.label
                      }, [
                        _createElementVNode("div", {
                          class: "storage-breakdown-dot",
                          style: _normalizeStyle({ background: item.color })
                        }, null, 4),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(item.label), 1),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(item.fmt), 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("button", {
                      class: "btn btn-ghost btn-login storage-clear-btn",
                      type: "button",
                      disabled: _ctx.storageClearing,
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearStorage && _ctx.clearStorage(...args)))
                    }, [
                      _cache[28] || (_cache[28] = _createElementVNode("svg", {
                        width: "13",
                        height: "13",
                        viewBox: "0 0 14 14",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          d: "M2 3.5h10M5.5 3.5V2.5h3v1M3 3.5l.8 8.2a1 1 0 0 0 1 .8h4.4a1 1 0 0 0 1-.8L11 3.5",
                          stroke: "currentColor",
                          "stroke-width": "1.3",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.storageClearing ? 'Limpando…' : 'Limpar dados offline'), 1)
                    ], 8, _hoisted_33),
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-login",
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.storageOpen = false))
                    }, "Fechar")
                  ])
                ], 64))
          ])
        ], 32))
      : _createCommentVNode("", true)
  ], 64))
}